import {
    UPDATE_SERVICE_PLAN_STATUS_ERROR,
    UPDATE_SERVICE_PLAN_STATUS_SUCCESS,
    UPDATE_SERVICE_PLAN_STATUS_START
} from "../../constants";
import showToaster from "../../helpers/toasterMessages/showToaster";
import { updateServicePlansStatus as mutation, getUserServicePlan as query } from "../../lib/graphql";

export function updateServicePlansStatus(id, isEnable) {
    return async (dispatch, getState, { client }) => {

        dispatch({ type: UPDATE_SERVICE_PLAN_STATUS_START });

        try {
            const { data: getPurchaseData } = await client.query({
                query,
                variables: {
                    servicePlanId: Number(id),
                },
                fetchPolicy: 'network-only'

            });

            if (getPurchaseData?.getUserServicePlan?.status == 200 && getPurchaseData?.getUserServicePlan?.results?.length > 0) {
                return showToaster({ messageId: 'unEnableServicePlan', toasterType: 'error' })
            }

            const { data } = await client.mutate({
                mutation: mutation,
                variables: {
                    id,
                    isEnable: !isEnable,
                },
            });

            const mutationResponse = data?.updateServicePlansStatus;

            if (mutationResponse?.status === 200) {
                dispatch({
                    type: UPDATE_SERVICE_PLAN_STATUS_SUCCESS
                });
                showToaster({
                    messageId: "servicePlanStatusSuccess",
                    toasterType: "success",
                });
                return true;
            } else {
                dispatch({ type: UPDATE_SERVICE_PLAN_STATUS_ERROR });
                showToaster({
                    messageId: "commonError",
                    toasterType: "error",
                    requestContent: mutationResponse?.errorMessage,
                });
            }

        } catch (error) {
            dispatch({
                type: UPDATE_SERVICE_PLAN_STATUS_ERROR
            });
            showToaster({
                messageId: "updateFailed",
                toasterType: "error",
            });
        }
    };
}
